import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getEventSegments(filter) {
  try {
    let res = await http.get('/Segment');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateEventSegment(id, data) {
  try {
    const res = await http.put(`/Segment/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewEventSegment(data) {
  try {
    const res = await http.post('Segment', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
